import { useEffect, useState } from 'react';

const STORAGE_KEY = 'estage_cookie_banner_dismissed';

export const CookieBanner: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const dismissed = localStorage.getItem(STORAGE_KEY);
      if (!dismissed) setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  const dismiss = () => {
    try {
      localStorage.setItem(STORAGE_KEY, new Date().toISOString());
    } catch {
      /* ignore */
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Cookie-Hinweis"
      style={{
        position: 'fixed',
        bottom: 16,
        left: 16,
        right: 16,
        zIndex: 9999,
        display: 'flex',
        justifyContent: 'center',
        pointerEvents: 'none',
      }}
    >
      <div
        style={{
          pointerEvents: 'auto',
          maxWidth: 560,
          width: '100%',
          background: '#FFFFFF',
          color: '#1A2023',
          borderRadius: 16,
          boxShadow: '0 10px 30px rgba(0,17,22,0.18), 0 2px 8px rgba(0,17,22,0.08)',
          border: '1px solid rgba(0,17,22,0.08)',
          padding: '20px 22px',
          fontFamily: "'Outfit Variable', 'Outfit', system-ui, -apple-system, sans-serif",
          fontSize: 14,
          lineHeight: 1.55,
        }}
      >
        <div style={{ fontWeight: 600, fontSize: 15, marginBottom: 6 }}>
          Cookies & Tracking
        </div>
        <div style={{ color: '#5F6B70', marginBottom: 14 }}>
          Wir verwenden Cookies und vergleichbare Technologien, um unsere Website bereitzustellen,
          Ihr Nutzererlebnis zu verbessern und unsere Angebote zu analysieren. Mehr dazu in unserer{' '}
          <a
            href="/datenschutz"
            style={{ color: '#FE6F17', textDecoration: 'underline' }}
          >
            Datenschutzerklärung
          </a>
          .
        </div>
        <div
          style={{
            display: 'flex',
            gap: 8,
            flexWrap: 'wrap',
            justifyContent: 'flex-end',
          }}
        >
          <button
            type="button"
            onClick={dismiss}
            style={{
              background: 'transparent',
              color: '#5F6B70',
              border: '1px solid rgba(0,17,22,0.12)',
              borderRadius: 999,
              padding: '8px 16px',
              fontWeight: 500,
              fontSize: 13,
              cursor: 'pointer',
              fontFamily: 'inherit',
            }}
          >
            Nur notwendige
          </button>
          <button
            type="button"
            onClick={dismiss}
            style={{
              background: '#FE6F17',
              color: '#FFFFFF',
              border: 'none',
              borderRadius: 999,
              padding: '8px 18px',
              fontWeight: 600,
              fontSize: 13,
              cursor: 'pointer',
              fontFamily: 'inherit',
              boxShadow: '0 4px 12px rgba(254,111,23,0.28)',
            }}
          >
            Alle akzeptieren
          </button>
        </div>
      </div>
    </div>
  );
};
